import React, { useEffect, useRef } from "react";
import "./DurationMenu.css";

const DurationMenu = ({
  showForwardMenu,
  showRewindMenu,
  onClose,
  forwardDuration,
  rewindDuration,
  onDurationChange,
  position,
}) => {
  const menuRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        onClose();
      }
    };

    if (showForwardMenu || showRewindMenu) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [showForwardMenu, showRewindMenu, onClose]);

  if (!showForwardMenu && !showRewindMenu) return null;

  return (
    <div
      className="duration-menu"
      ref={menuRef}
      style={{
        bottom: position?.bottom || "auto",
        left: position?.left || 0,
      }}
    >
      {[5, 15, 30].map((duration) => (
        <div
          key={duration}
          className={`duration-menu-item ${
            (duration === rewindDuration && showRewindMenu) ||
            (duration === forwardDuration && showForwardMenu)
              ? "active"
              : ""
          }`}
          onClick={() => onDurationChange(duration)}
        >
          <div className="duration-menu-item-content">
            <span>{duration} сек</span>
          </div>
        </div>
      ))}
    </div>
  );
};

export default DurationMenu;
